import React from "react";
import { MessageSquare, Search, FileText, Send, Eye, CheckCircle2 } from "lucide-react";

const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      icon: <MessageSquare />,
      title: "Consultation & Search",
      description: "We start with a free consultation to understand your brand and business goals. Our team then conducts a comprehensive trademark search across federal, state, and common law databases to identify potential conflicts and assess the strength of your proposed mark, ensuring the best chance of approval.",
    },
    {
      number: "02",
      icon: <FileText />,
      title: "Application Preparation & Filing",
      description: "We prepare your complete trademark application with precision, selecting appropriate trademark classes, crafting accurate descriptions, and gathering all required documentation. Your application is then electronically filed with the USPTO, and you receive confirmation with your official serial number.",
    },
    {
      number: "03",
      icon: <CheckCircle2 />,
      title: "Monitoring & Registration",
      description: "We monitor your application throughout the USPTO examination process and handle any office actions that arise. Upon approval, your trademark is published and registered. We provide ongoing monitoring and maintenance services to keep your brand protection active and enforceable.",
    },
  ];

  return (
    <section id="process" className="process-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Trademark Registration Process</h2>
          <p className="section-subtitle">
            Three Simple Steps to Complete Brand Protection
          </p>
        </div>

        <div className="process-intro-card">
          <p className="process-intro-text">
            Registering a trademark doesn't have to be complicated. Our streamlined three-step process takes you from initial consultation to full federal registration with complete transparency and expert guidance at every stage. Here's exactly what to expect when you work with trademarkIcontext:
          </p>
        </div>

        <div className="process-timeline">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="step-number-badge">{step.number}</div>
              <div className="step-content-card">
                <div className="step-header">
                  <div className="step-icon">{step.icon}</div>
                  <div className="step-title-group">
                    <h3 className="step-title">{step.title}</h3>
                    <span className="step-timeline">{step.timeline}</span>
                  </div>
                </div>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
